export default __webpack_public_path__ + "static/media/Utric's Healing Cloak.8455ce92.jpg";